import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-1 d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-4 card-title" }, "Job configuration")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex justify-content-start w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.sendJobEmail,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sendJobEmail) = $event)),
          size: "large",
          label: "Send Job emails"
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}